angular.module('app').component('adminTable', {
    templateUrl: 'events/components/table.html',
    transclude: true
});

angular.module('app').service('adminTableDragMirror', function($window) {
    var cellStyleProperties = [
        'backgroundColor',
        'borderBottomColor',
        'borderBottomStyle',
        'borderBottomWidth',
        'borderLeftColor',
        'borderLeftStyle',
        'borderLeftWidth',
        'borderRightColor',
        'borderRightStyle',
        'borderRightWidth',
        'borderTopColor',
        'borderTopStyle',
        'borderTopWidth',
        'color',
        'fontFamily',
        'fontSize',
        'fontStyle',
        'fontWeight',
        'letterSpacing',
        'lineHeight',
        'paddingBottom',
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'textAlign',
        'textTransform',
        'whiteSpace'
    ];

    function unwrap(element) {
        return element && (element[0] || element);
    }

    function copyCellStyles(sourceCell, mirrorCell) {
        var sourceRect = sourceCell.getBoundingClientRect();
        var sourceStyle = $window.getComputedStyle(sourceCell);

        mirrorCell.style.boxSizing = 'border-box';
        mirrorCell.style.display = 'flex';
        mirrorCell.style.flex = '0 0 ' + sourceRect.width + 'px';
        mirrorCell.style.width = sourceRect.width + 'px';
        mirrorCell.style.height = sourceRect.height + 'px';
        mirrorCell.style.minWidth = '0';
        mirrorCell.style.overflow = 'hidden';

        cellStyleProperties.forEach(function(property) {
            mirrorCell.style[property] = sourceStyle[property];
        });

        if(sourceStyle.verticalAlign === 'top') {
            mirrorCell.style.alignItems = 'flex-start';
        } else if(sourceStyle.verticalAlign === 'bottom') {
            mirrorCell.style.alignItems = 'flex-end';
        } else {
            mirrorCell.style.alignItems = 'center';
        }

        if(sourceStyle.textAlign === 'center') {
            mirrorCell.style.justifyContent = 'center';
        } else if(sourceStyle.textAlign === 'right') {
            mirrorCell.style.justifyContent = 'flex-end';
        } else {
            mirrorCell.style.justifyContent = 'flex-start';
        }
    }

    this.register = function(scope, bagName) {
        return scope.$on(bagName + '.cloned', function(event, mirror, source, cloneType) {
            var mirrorRow = unwrap(mirror);
            var sourceRow = unwrap(source);
            var sourceRect;
            var sourceStyle;

            if(cloneType !== 'mirror' || !mirrorRow || !sourceRow || sourceRow.tagName !== 'TR') {
                return;
            }

            sourceRect = sourceRow.getBoundingClientRect();
            sourceStyle = $window.getComputedStyle(sourceRow);
            mirrorRow.style.boxSizing = 'border-box';
            mirrorRow.style.display = 'flex';
            mirrorRow.style.width = sourceRect.width + 'px';
            mirrorRow.style.height = sourceRect.height + 'px';
            mirrorRow.style.backgroundColor = sourceStyle.backgroundColor;
            mirrorRow.style.color = sourceStyle.color;

            Array.prototype.forEach.call(sourceRow.children, function(sourceCell, index) {
                if(mirrorRow.children[index]) {
                    copyCellStyles(sourceCell, mirrorRow.children[index]);
                }
            });
        });
    };
});
